import React from 'react';
import PropTypes from 'prop-types';

import {ReactComponent as Logo} from 'portavita-logo.svg';

// MUI Components
import {Grid, Typography, useMediaQuery, useTheme, IconButton} from '@mui/material';
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';

// Custom components
import ProfileInfo from 'components/profile-info';

// Constants
import {APP_HEADER_COMPONENT_TEST_ID} from 'testidConstants.js';
import {StyledAppBar} from 'components/styled';

//REDUX
import {connect} from 'react-redux';
import {setIsMenuDrawerOpen} from 'redux/slices/appHeaderSlice';

const AppHeader = ({userInfo, setIsDrawerOpen, isBurgerButtonShown}) => {
  const theme = useTheme();
  const hidden = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <StyledAppBar data-testid={APP_HEADER_COMPONENT_TEST_ID}>
      <Grid container direction="row">
        <Grid item alignItems="center" container xs={11}>
          {!hidden ? (
            <Logo style={{margin: '6px 32px 16px 32px'}} />
          ) : (
            isBurgerButtonShown && (
              <IconButton onClick={() => setIsDrawerOpen(true)}>
                <MenuOutlinedIcon color="white" />
              </IconButton>
            )
          )}
          <Typography style={{width: 'auto', marginLeft: !isBurgerButtonShown && '24px'}} variant="h6">
            DVZA Support Console
          </Typography>
        </Grid>
        <Grid item container justifyContent="flex-end" xs={1}>
          <ProfileInfo userInfo={userInfo} />
        </Grid>
      </Grid>
    </StyledAppBar>
  );
};

AppHeader.propTypes = {
  userInfo: PropTypes.object,
  setIsDrawerOpen: PropTypes.func,
  isBurgerButtonShown: PropTypes.bool
};

const mapDispatchToProps = (dispatch) => {
  return {
    setIsDrawerOpen: (isOpen) => dispatch(setIsMenuDrawerOpen(isOpen))
  };
};

export default connect(null, mapDispatchToProps)(AppHeader);
